import gql from 'graphql-tag';

export const DomainGetAllQuery = gql`
  query DomainGetAllQuery {
    DomainsV1Resource {
      domains: getAll {
        elements {
          id
          topic
          slug
          name
          description
          backgroundImageUrl
          subdomains {
            elements {
              id
              slug
              topic
              name
              domainId
              description
            }
          }
        }
      }
    }
  }
`;
